export default {
  getCityStatus: '/v3/recruit/cityStatus'
}
